import dayjs from 'dayjs';
import { State } from 'features/CampaignPlanning/Tab';
import { DateList } from 'redux/slice/strategy/strategy';

export function convertDateFormat(inputDate: string): string {
  // Split the input date using the "-" delimiter
  const dateArray: string[] = inputDate.split('-');
  // Rearrange the date components in the desired format
  return `${dateArray[2]}-${dateArray[1].padStart(
    2,
    '0'
  )}-${dateArray[0].padStart(2, '0')}`;
}

export const convertISOToLocaleDateString = (isoDate: string | Date) => {
  return convertDateFormat(
    new Date(isoDate).toLocaleString('en-GB').split(',')[0].replace(/\//g, '-')
  );
};

export function getDatesBetween(currentDate: Date, endDate: Date): DateList[] {
  const dates: DateList[] = [];
  if (currentDate > endDate)
    throw new Error('Start date must be before end date');
  let count = 1;
  while (currentDate <= endDate) {
    dates.push({
      date: convertISOToLocaleDateString(new Date(currentDate).toISOString()),
      state: State.FUTURE,
      dayCount: count++,
    });
    currentDate = new Date(currentDate.setDate(currentDate.getDate() + 1));
  }

  return dates;
}

export function formatDuration(startDate?: string, endDate?: string) {
  if (!startDate || !endDate) return '';

  const start = dayjs(startDate);
  const end = dayjs(endDate);

  if (!(start.year() === end.year())) {
    return `Duration: ${start.format('DD MMM YYYY')}-${end.format(
      'DD MMM YYYY'
    )}`;
  }

  if (!(start.month() === end.month())) {
    return `Duration: ${start.format('DD MMM')}-${end.format('DD MMM YYYY')}`;
  }
  return `Duration: ${start.format('DD')}-${end.format('DD MMM YYYY')}`;
}
